import React, { useState } from 'react';
import Image from 'next/image';
import styles from './BookTourPopUp.module.scss';
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import pre from "@/assets/icons/pre.svg";
import prep from "@/assets/icons/prep.svg";
import prec from "@/assets/icons/prec.svg";
import prepc from "@/assets/icons/prepc.svg";


interface bookTourType {
    showPopup:boolean;
    setShowPopup:(value: boolean | ((prev: boolean) => boolean)) => void;
}

const BookTourPopUp = ({showPopup,setShowPopup}:bookTourType) => {
  const { isMobileDevice } = useSelector((state: any) => state.data);

  const [selectedTour, setSelectedTour] = useState("preprep");

  return (
    <Modal
      show={showPopup}
      onHide={() => setShowPopup(false)}
      backdrop="static"
      keyboard={false}
      size="xl"
      dialogClassName={styles.modalCustom}
      contentClassName={styles.modalContent}
      backdropClassName={styles.modalBackdrop}
    >
      <Modal.Header
        className={isMobileDevice ? "justify-content-center" : "justify-content-end"}
      >
        <Button className={styles.btnclose} 
        onClick={() => {
          setShowPopup(false);
          setSelectedTour("preprep");
        }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.9994 15L9 9M9.00064 15L15 9"
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
              stroke="white"
            />
          </svg>
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className={styles.tourWrapper}>
          {/* <p className="mb-4">
            Leave your contact details and our team will be in touch shortly.
          </p> */}

          <div className={styles.optionsContainer}>
            {tours.map((tour) => (
              <div
                key={tour.id}
                className={`${styles.optionCard} ${selectedTour === tour.id ? styles.selected : ""
                  }`}
                onClick={() => setSelectedTour(tour.id)}
              >
               <Image
                  src={selectedTour === tour.id ? tour.select : tour.img}
                  alt={tour.label}
                  height={40}
                  width={40}
                />
                <div className={styles.label}>{tour.label}</div>
              </div>
            ))}
          </div>

          <div className={styles.iframeContainer}>
            {selectedTour === "preprep" && (
              <iframe
                src="https://aldareducation1.my.site.com/SUMOScheduler/apex/sumoapp__eventregister?regId=a1vUz000000DnhFIAS&isIframe=true"
                title="Pre-Prep Tour"
                allow="geolocation"
                frameBorder="0"
                style={{
                  width: "100%",
                  height: "658px",
                  border: "1px solid #ccc",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  marginTop: "24px",
                }}
              />
            )}
            {selectedTour === "prep" && (
              <iframe
                src="https://aldareducation1.my.site.com/SUMOScheduler/apex/sumoapp__eventregister?regId=a1vNM000000yEphYAE&isIframe=true"
                title="Prep Tour"
                allow="geolocation"
                frameBorder="0"
                style={{
                  width: "100%",
                  height: "658px",
                  border: "1px solid #ccc",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  marginTop: "24px",
                }}
              />
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const tours = [
  {
    id: "preprep",
    label: "Group Pre-Prep Tour",
    img: pre,
    select:prec
  },
  {
    id: "prep",
    label: "Group Prep Tour",
    img: prep,
    select:prepc
  },
];

export default BookTourPopUp;
